import { registerWorkflowProduct } from "src/views/products/workflow/registry";

/**
 * The 10 CFR 50.59 evaluation product.
 *
 * productKey is the backend product slug — sending it as
 * `conversation.product` (at create-dialogue AND per converse turn) is what
 * activates the workflow delegation tools, the per-criterion context
 * injector, and the lead persona resolver. licenseModule stays
 * "licensing-compliance": a new product does not imply a new entitlement.
 */
export const FIFTY_FIFTY_NINE_PRODUCT = registerWorkflowProduct({
  productKey: "fifty-fifty-nine-evaluation",
  licenseModule: "licensing-compliance",
  displayName: "50.59 Evaluation",
  basePath: "/fifty-fifty-nine",
  streamKey: "fifty-fifty-nine",
  testIdPrefix: "ffn",
  leadSlotKey: "lead",
  // No runId URL segment: the record is reachable through the dialogue.
  buildChatUrlForDialogue: () => async (dialogueId: number) =>
    `/fifty-fifty-nine/chat/${dialogueId}`,
});
